import React, { Component, Suspense, createContext } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import ContextAppState from './ContextAppState'
import 'antd/dist/antd.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

export const contextApp = createContext();
function App() {
  const allStates = ContextAppState();
  return (
    <contextApp.Provider value={{ ...allStates }}>
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Trang chủ" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </HashRouter>
    </contextApp.Provider>
  )
}

export default App
